export default __webpack_public_path__ + "static/media/tranquil.011cdfbe.png";